export const CART_PAGE_DATASET_KEY = 'CART_PAGE_DATASET_KEY';
export const CART_PAGE_DELETED_USERS_KEY = 'CART_PAGE_DELETED_USERS_KEY';
export const CART_PACKAGES_LOCAL_STORAGE_KEY =
  'CART_PACKAGES_LOCAL_STORAGE_KEY';
export const INITIAL_DATASET_LOCAL_STORAGE_KEY =
  'INITIAL_CART_PAGE_DATASET_LOCAL_STORAGE_KEY';
export const USER_SAVED_PACKAGES_LOCAL_STORAGE_KEY =
  'USER_SAVED_PACKAGES_LOCAL_STORAGE_KEY';
